import { LOGOUT_REQUESTED } from 'constants/actions';


export const logoutRequested = (payload) => {
  return { type: LOGOUT_REQUESTED, payload };
};
